import { Action, Tag } from 'types';

export interface TagReducer {
  tagsInArray: Tag[];
  tagsInAlphabeticalIndex: {
    [alphabet: string]: Tag[];
  };
}

const initialState: TagReducer = {
  tagsInArray: [],
  tagsInAlphabeticalIndex: {},
};

export default (
  state: TagReducer = initialState,
  action: Action
): TagReducer => {
  switch (action.type) {
    case 'FETCH_TAGS_FULFILLED':
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
